/**
 * /en/admin/structure/paragraphs_type/form_element_submit/fields
 */

import FormElementParagraph from "../paragraphs/form-element-paragraph.es6.js";
import LabelFormElementParagraphField
  from "../fields/form-element-label-paragraph-field.es6.js";

export default class SelectFormElementParagraph extends FormElementParagraph {
  get label() {
    return new LabelFormElementParagraphField({
      machineName: 'field_form_label',
      parentElement: this,
    });
  }

  constructor({ parentElement }) {
    super({
      machineName: 'form_element_select',
      parentElement,
    });
  }

  selectOption(value) {
    const $select = this.element.$();
    $select.val(value);
    $select.trigger('change'); // Notify any JS components that the value changed
  }

  initialize() {
    const $select = this.element.$();

    $select.select2({
      // Select2 options documentation: https://select2.org/options
      theme: 'classic',
    });
  }
}

(() => {
  const selectFormElement = new SelectFormElementParagraph({});
  selectFormElement.onRendered(async () => {
    selectFormElement.initialize();
  });
})(Drupal);
